<template>
  <div class="column">
    <label v-if="label !== ''">{{ t(label) }}</label>
    <input
      :type="type"
      @input="$emit('update', $event.target.value.trim())"
      :value="value"
      :required="required"
      :placeholder="t(placeholder)"
    />
    <span v-if="errorMsg !== ''" class="error">{{ t(errorMsg) }}</span>
  </div>
</template>

<script>
export default {
  name: 'Input',
  emits: ['update'],
  props: {
    type: { type: String, default: 'text' },
    value: { type: String, default: '' },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    label: { type: String, default: '' },
    errorMsg: { type: String, default: '' },
  },
  setup() {},
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.column {
  position: relative;

  .error {
    position: absolute;
    bottom: 0;
    right: 5px;
    font-size: 0.8rem;
    color: var(--invalid);
  }
}
</style>
